<div class="container mt-3">

  <div class="text-center mb-4" *ngIf="subscription">
    <h3>Your current plan: {{ subscription.name }}</h3>
    <div class="fw-bold">Current Number of Properties : {{ subscription.numberOfProperties }}</div>
    <div class="fw-bold" *ngIf="subscription.name == 'Starter'">Current Number of Tenancies : {{ subscription.numberOfTenancies }}</div>
  </div>

  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 justify-content-center">

    <!-- Starter Plan Card -->
    <div class="col">
      <div class="card h-100">
        <div class="card-header text-center py-3">
          <h4 class="my-0 fw-normal">Starter</h4>
        </div>
        <div class="card-body d-flex flex-column p-4">
          <h1 class="card-title pricing-card-title text-center mb-3">£0<small class="text-muted fw-light">/mo</small></h1>
          <p class="text-center text-muted mb-4">Free Package - Up to 1 Property & 5 Tenancies</p>
          <ul class="list-unstyled my-4 flex-grow-1">
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Property Management</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Secure Document Management</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Certificate Administration</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Maintenance Management</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Tenant Management</li>
          </ul>
          <button type="button" class="w-100 btn btn-lg btn-outline-primary" [disabled]="subscription?.name === 'Starter'" (click)="onSubscribeClick('Starter')">
            {{ subscription?.name === 'Starter' ? 'Current Plan' : 'Subscribe' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Essential Plan Card (Most Popular) -->
    <div class="col">
      <div class="card h-100 border-primary shadow"> <!-- Added shadow for emphasis -->
        <div class="card-header text-center text-white bg-primary border-primary py-3">
           <h4 class="my-0 fw-normal">Essential <span class="badge bg-light text-primary ms-2">Most Popular</span></h4>
        </div>
        <div class="card-body d-flex flex-column p-4">
          <h1 class="card-title pricing-card-title text-center mb-3">£4.99<small class="text-muted fw-light">/mo</small></h1>
          <p class="text-center text-muted mb-4">Starter Package - Up to 5 Properties & Unlimited Tenancies</p>
          <ul class="list-unstyled my-4 flex-grow-1">
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Access to all features</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Important date reminders</li>
            <!-- Add other features specific to Essential if known -->
          </ul>
           <button type="button" class="w-100 btn btn-lg btn-primary" [disabled]="subscription?.name === 'Essential'" (click)="onSubscribeClick('Essential')">
             {{ subscription?.name === 'Essential' ? 'Current Plan' : 'Subscribe' }}
           </button>
        </div>
      </div>
    </div>

    <!-- Semi-Pro Plan Card -->
    <div class="col">
      <div class="card h-100">
        <div class="card-header text-center py-3">
          <h4 class="my-0 fw-normal">Semi-Pro</h4>
        </div>
        <div class="card-body d-flex flex-column p-4">
          <h1 class="card-title pricing-card-title text-center mb-3">£9.99<small class="text-muted fw-light">/mo</small></h1>
          <p class="text-center text-muted mb-4">Semi-Pro Package - Up to 15 Properties & Unlimited Tenancies</p>
           <ul class="list-unstyled my-4 flex-grow-1">
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Access to all features</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Important date reminders</li>
             <!-- Add other features specific to Semi-Pro if known -->
          </ul>
          <button type="button" class="w-100 btn btn-lg btn-primary" [disabled]="subscription?.name === 'Semi-Pro'" (click)="onSubscribeClick('Semi-Pro')">
            {{ subscription?.name === 'Semi-Pro' ? 'Current Plan' : 'Subscribe' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Pro Plan Card -->
    <div class="col">
      <div class="card h-100">
        <div class="card-header text-center py-3">
          <h4 class="my-0 fw-normal">Pro</h4>
        </div>
        <div class="card-body d-flex flex-column p-4">
          <h1 class="card-title pricing-card-title text-center mb-3">£14.99<small class="text-muted fw-light">/mo</small></h1>
          <p class="text-center text-muted mb-4">Pro Package - Unlimited Properties & Unlimited Tenancies</p>
           <ul class="list-unstyled my-4 flex-grow-1">
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Access to all features</li>
            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Important date reminders</li>
             <!-- Add other features specific to Pro if known -->
          </ul>
           <button type="button" class="w-100 btn btn-lg btn-primary" [disabled]="subscription?.name === 'Pro'" (click)="onSubscribeClick('Pro')">
             {{ subscription?.name === 'Pro' ? 'Current Plan' : 'Subscribe' }}
           </button>
        </div>
      </div>
    </div>

  </div> <!-- End row -->

  <!-- Original Stripe Pricing Table (Commented Out) -->
  <!--
  <div class="PricingTable is-whiteButtonText is-lightColorBackground has-fourItems flex-container direction-column justify-content-center align-items-center" data-testid="pricing-table-container" style="--pt-color-primary: #e3057d; background-color: rgb(255, 255, 255);"><div class="PricingTable-grid"> ... [Original Scraped Content] ... </div></div>
  -->

  <!-- Stripe Integration Elements (Commented Out) -->
  <!-- test table -->
  <!-- <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
  <stripe-pricing-table *ngIf="userProfile"
                        pricing-table-id="prctbl_1Pl7rXRpr2JcH9JNNztNyreu"
                        publishable-key="pk_test_51PienlRpr2JcH9JNgSYc76JTcK48q7n2BT5uNSduoG87qtE02IYVlmf0ibDwI5mDj5bLlnwzl0F91u4rkgbuZ4oK00cTZlTF7c"
                        [customer-email]="userProfile?.email"
                        [client-reference-id]="userProfile?.id">
  </stripe-pricing-table> -->

  <!-- prod table -->
  <!-- <stripe-pricing-table *ngIf="userProfile"
                            pricing-table-id="prctbl_1PiianRpr2JcH9JNlTTptzFK"
                            publishable-key="pk_live_51PienlRpr2JcH9JNC2xmlJyGysudTLNYnI0Ec1wzW3g2k4QBJp6xXZtkmxDVb7ZmMOa87wZOxbdVbEYk9jTFtkJF00M1G7KcF0"
                            [customer-email]="userProfile?.email"
                            [client-reference-id]="userProfile?.id">
      </stripe-pricing-table> -->
  <!-- <stripe-pricing-table pricing-table-id="prctbl_1PiianRpr2JcH9JNlTTptzFK"
  publishable-key="pk_live_51PienlRpr2JcH9JNC2xmlJyGysudTLNYnI0Ec1wzW3g2k4QBJp6xXZtkmxDVb7ZmMOa87wZOxbdVbEYk9jTFtkJF00M1G7KcF0">
  </stripe-pricing-table> -->

</div> <!-- End container -->
